import {
  productProjectionFragment,
  productProjectionVariantFragment,
} from '@/graphql/fragments/productProjection';
import { ProductProjectionResult, WithAllVariants } from '@/utils/productProjection';

export interface Variables {
  customProductKey: [string];
  locale?: 'en';
}

export type CustomProductProjectionResult = Extract<ProductProjectionResult, WithAllVariants>;

export interface CustomProductProjectionSearchResponse {
  data: {
    productProjectionSearch: {
      results: CustomProductProjectionResult[];
    };
  };
}

export const CustomProductProjectionSearch = `query CustomProductProjectionSearch(
  $customProductKey: [String!]!
  $locale: Locale = "en"
) {
  productProjectionSearch(
    markMatchingVariants: true
    queryFilters: [
      {
        model: {
          value: {
            path: "variants.attributes.customProduct.key",
            values: $customProductKey
          }
        }
      }
      {
        model: {
          value: {
            path: "variants.attributes.active",
            values: ["true"]
          }
        }
      }
    ]
  ) {
    results {
      allVariants(onlyMatching: true) {
        ...productProjectionVariantFragment
      }
      ...productProjectionFragment
    }
  }
}

${productProjectionFragment}

${productProjectionVariantFragment}
`;
